import { type CSSObject } from '@emotion/react';
import {
  type TextFieldStylesProps,
  useTextFieldStyles,
} from '../textField.styles';
import { useTheme } from '../../../../theme';
import { inputBaseClasses } from '@mui/material/InputBase';

type UseStylesReturn = Record<
  | 'container'
  | 'adornmentContainer'
  | 'adornment'
  | 'searchIcon'
  | 'startAdornment',
  CSSObject
>;

export const useSearchBarStyles = (
  props: TextFieldStylesProps,
): UseStylesReturn => {
  const styles = useTextFieldStyles(props);
  const theme = useTheme();

  return {
    container: {
      ...styles.root,

      [`& .${inputBaseClasses.root}`]: {
        ...(styles.root[`& .${inputBaseClasses.root}`] as CSSObject),
        gap: 0,
      },

      [`& .${inputBaseClasses.input}`]: {
        ...(styles.root[`& .${inputBaseClasses.input}`] as CSSObject),
        padding: theme.spacing(0),
      },
    },
    adornmentContainer: {
      display: 'flex',
      gap: theme.spacing(2),
      margin: theme.spacing(0, 1, 0, 2),
      alignItems: 'center',
      justifyContent: 'center',
    },
    adornment: {
      all: 'unset',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor:
        props.disabled === true || props.contentEditable === false
          ? 'default'
          : 'pointer',
      '&:focus': {
        outline: `2.5px solid ${theme.button.focused.default}`,
        borderColor: theme.button.focused.default,
      },
    },
    searchIcon: {
      color: theme.icon.primary,
    },
    startAdornment: {
      padding: theme.spacing(0, 2),
    },
  };
};
